<div [ngClass]="{container: useContainer}">
    <app-loading [loaded]="loaded"></app-loading>
    <div *ngIf="loaded">
        <ng-content></ng-content>
    </div>
</div>